var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',[_c('button',{on:{"click":_vm.onClick}},[_vm._v("Button ("+_vm._s(_vm.buttonLabel())+")")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }